import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Divider, Input, Select} from "antd";

const {Option} = Select;

function mapStateToProps(state) {
    return {};
}

let index = 0;

class SelectAddNew extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: ['Baseline Average', 'Post-Period Average', 'Custom'],
            name: props.price ?? null,
        }
    }

    componentDidUpdate(prevProps) {
        // 当 props.price 发生变化时更新 name
        if (prevProps.price !== this.props.price) {
            this.setState({
                name: this.props.price ?? null,
            });
        }
    }

    onNameChange = event => {
        this.setState({
            name: event.target.value,
        });
        this.props.onSelect('Custom', event.target.value)
    };

    handleChange = (value) => {
        if (value === 'Custom') {
            // 切换到 Custom 时，用当前显示的计算价格作为初始值
            const customPrice = this.props.calculatedPrice ?? this.state.name ?? null;
            this.setState({ name: customPrice });
            this.props.onSelect(value, customPrice);
        } else {
            this.props.onSelect(value, null);
        }
    }

    render() {
        const {items, name} = this.state;
        return (
            <div className={'flex'}>
                <Select
                    onChange={this.handleChange}
                    placeholder={this.props.placeholder}
                    defaultValue={this.props.default}
                    value={this.props.value}
                    dropdownRender={menu => (
                        <div>
                            {menu}

                        </div>
                    )}
                >
                    {items.map(item => (
                        <Option key={item}>{item}</Option>
                    ))}
                </Select>

                {this.props.value === 'Custom' ? (
                    <Input prefix={'$ '} style={{width:'80px'}} value={name} onChange={this.onNameChange}/>
                ) : (
                    <Input 
                        prefix={'$ '} 
                        style={{width:'80px'}} 
                        value={this.props.calculatedPrice?.toFixed(3)} 
                        disabled 
                    />
                )}
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
)(SelectAddNew);
